import React from 'react';
import { useClassName } from 'common/hooks';
import './labels.less';

export default function Labels({ labels }) {
  const classNames = useClassName('CLPLabels');
  return (
    <div className={classNames('container')}>
      {labels.map((label) => (
        <span key={label}>{label}</span>
      ))}
    </div>
  );
}
